import { t } from '@hh/global.js'

class OkendoQuiz extends HTMLElement {
  constructor() {
    super()
    
    const observer = new MutationObserver(() => {

      const checkboxLabel = this.querySelector('.c-emailInput .c-checkbox-label')
      
      if (checkboxLabel && checkboxLabel.dataset.modified != 'true') {
        let consentText = ''
        
        try {
          consentText = t('newsletter.consent')
        } catch (error) {
          console.warn('OkendoQuiz: Error getting translation:', error)
        }
        
        if (!consentText && window.langMessages && window.langMessages['newsletter.consent']) {
          consentText = window.langMessages['newsletter.consent']
        }
        
        if (!consentText) {
          consentText = 'I want to receive the schleich® newsletter by e-mail with news and offers. I certify I am at least 18 years of age and have read and agree to the <a href="https://www.schleich-s.com/en/US/legal/privacy-policy/" target="_blank" rel="noreferrer">privacy policy</a> and <a href="https://privacy.schleich-s.com/#financial-incentive" target="_blank" rel="noreferrer">Notice of Financial Incentive</a>.'
        }
        
        checkboxLabel.innerHTML = consentText
        checkboxLabel.dataset.modified = 'true'
      } 
    })
    
    observer.observe(this, { 
      childList: true, 
      subtree: true 
    })
  }
}

if (!customElements.get('oke-quiz')) {
  customElements.define('oke-quiz', OkendoQuiz)
} 
